import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

interface WithdrawResettingProps {
  store: WithdrawStore
}

export const WithdrawResetting = observer(({ store }: WithdrawResettingProps) => {
  return (
    <ShortMessageBox variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
      <BodySM className="text-t200">Resetting your veSCALE. Please wait for the transaction to complete...</BodySM>
    </ShortMessageBox>
  )
})
